<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/move-step2')"></span>
    </div>
    <div class="title">从哪里搬去哪里？</div>
    <div class="main">
      <router-link to="/move-step3/out">
        <div class="in-address" >
          <div class="move-title">搬出地址 <span class="arrow-right pull-right"> <span class="icon-chevron-right"></span> </span></div>
          <div v-if="!order.data.move_out_street" class="address-empty">请填写搬出地址</div>
          <div v-else>
          <div class="address-detail">{{order.data.move_out_street}}, {{order.data.move_out_suburb}}, {{order.data.move_out_state}}, {{order.data.move_out_postcode}}</div>
          <div class="address-parking">{{toTextFloor(order.data.move_out_floor)}} {{toTextParking(order.data.move_out_parking)}}</div>
          </div>
        </div>
      </router-link>

      <div class="hr"></div>

      <div v-for="(item, index) in order.data.pathway_address">
        <div @click="goto('/move-step3/wp?wpKey='+index)">
          <div class="in-address" >
            <div class="move-title">途经点 {{order.data.pathway_address.length>1 ? index+1 : ''}} <span class="arrow-right pull-right"> <span class="icon-chevron-right"></span> </span></div>
            <div class="address-detail"><span v-show="item.unit">{{item.unit}}, </span>{{item.street}}, {{item.suburb}}, {{item.state}}, {{item.postcode}}</div>
            <!-- <div class="address-parking">{{toTextFloor(item.floor)}} {{toTextParking(item.parking)}}</div> -->
          </div>
        </div>
        <div class="hr"></div>
      </div>

      <router-link to="/move-step3/in">
        <div class="in-address" >
          <div class="move-title">搬入地址 <span class="arrow-right pull-right"> <span class="icon-chevron-right"></span> </span></div>
          <div v-if="!order.data.move_in_street" class="address-empty">请填写搬入地址</div>
          <div v-else>
          <div class="address-detail">{{order.data.move_in_street}}, {{order.data.move_in_suburb}}, {{order.data.move_in_state}}, {{order.data.move_in_postcode}}</div>
          <div class="address-parking">{{toTextFloor(order.data.move_in_floor)}} {{toTextParking(order.data.move_in_parking)}}</div>
          </div>
        </div>
      </router-link>

      <div class="hr"></div>

      <div class="more-address"></div>
    </div>

    <div class="more-detail">
      <span class="check-detail"></spab><span class="icon-plus" style="color:#fe9567"></span> <router-link to="/move-step3/wp" class="waypoint">新增途经点</router-link></span>
    </div>

    <div class="btn-box-fix">
      <div class="btn-container">
        <div class="btn" @click="checkSubmit()" :class="{ active: allFilled()}" >下一步</div>
      </div>
    </div>
    <img :src="pixelURL('move','dizhi')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'step3',
  data () {
    return {
      'order':{}
    }
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "move"){
        this.order = localParsed;
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  },
  methods: {
    allFilled(){
       if(this.order.data.move_in_name &&
          this.order.data.move_in_phone &&
          this.order.data.move_in_street &&
          this.order.data.move_in_suburb &&
          this.order.data.move_in_state &&
          this.order.data.move_in_floor &&
          this.order.data.move_in_name &&
          this.order.data.move_in_phone &&
          this.order.data.move_in_postcode &&
          this.order.data.move_in_parking &&
          this.order.data.move_out_name &&
          this.order.data.move_out_phone &&
          this.order.data.move_out_street &&
          this.order.data.move_out_suburb &&
          this.order.data.move_out_state &&
          this.order.data.move_out_floor &&
          this.order.data.move_out_name &&
          this.order.data.move_out_phone &&
          this.order.data.move_out_postcode &&
          this.order.data.move_out_parking){
            return true;
        }
    },
    toTextParking(theVar){
      let result = '';
      switch (theVar) {
        case "1":
          result = '已预留Loading Dock'
          break;
        case "2":
          result = '已预留停车位'
          break;
        case "3":
          result = '无停车位'
          break;
        default:
          console.log("Sorry, we are out of control.");
      }
      return result;
    },
    toTextFloor(theVar){
      let result = '';
      switch (theVar) {
        case "1":
          result = '有电梯/住G层'
          break;
        case "2":
          result = '1层 无电梯'
          break;
        case "3":
          result = '2层 无电梯'
          break;
        case "4":
          result = '3层 无电梯'
          break;
        case "5":
          result = '4层 无电梯'
          break;
        case "6":
          result = '5层 无电梯'
          break;
        case "7":
          result = '5层以上 无电梯'
          break;
        default:
          console.log("Sorry, we are out of .");
      }
      return result;
    },
    checkSubmit(){
        if(this.allFilled()){
            this.orderUpdateAll('/move-step4');
        }
        else{
            alert('请填写完所有地址信息')
        }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.main{
  padding:20px 20pt 0 20pt;
}
.hr{
  border-top:1px solid #eee;
  margin:16pt 0;
}
.address-empty{
  color:#ccc;
  font-size:1.2em;
}

.address-detail{
  color:#666;
  font-size:1.1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.address-parking{
  color:#aaa;
  font-size:1em;
}

.arrow-right{
  color:#ddd;
}
.move-title{
  font-weight:bold;
  font-size:1.2em;
  color:#555;
  margin-bottom:4pt;
}

.waypoint{
  font-weight:bold;
  font-size:1.2em;
  color:#777;
  margin-bottom:4pt;
}

select{
  -webkit-appearance: none;
  border: 0;
  outline: 0;
  background-color: transparent;
  width: 100%;
  font-size: inherit;
  height: 45px;
  line-height: 45px;
  position: relative;
  z-index: 1;
}

.fade-enter-active{
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.check-detail{
  border: 2px solid #e3e3e3;
  padding: 8px 18px 8px 14px;
  margin-top: 14px;
  display: inline-block;
  border-radius: 50px;
}

.more-detail{
  text-align:center;
  margin-bottom:20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/move/step3.vue